/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";
import notificationState from "../../states/notificationState";
import getSchema from "../../lib/api/getSchema";
import DeleteRecordButton from "../input/DeleteRecordButton";

import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import TkDeliveryDetailButton from "../input/TkDeliveryDetailButton";

function MomSysDeliveryDetail(props) {

    const { id, onSelectMst, onDetailEmpty } = props;

    const [, setHeight] = useState();

    const [api, setApi] = useState();

    const [grid, setGrid] = useState();

    const [schema, setSchema] = useState();

    const [ isEmpty, setIsEmpty ] = useState();

    const { t } = useTranslation();

    const [ , setNotification ] = useRecoilState(notificationState);

    const handleResize = () => {

        setHeight(document.documentElement.offsetHeight - 96);

    };

    useEffect(() => {

        let mounted = true;
        window.addEventListener("resize", handleResize);
        handleResize();

        (async () => {

            let schema = await getSchema("MomSysShipmentDetail");

            if ( mounted ) {

                setSchema(schema);
                
            }

        })();

        return ( () => {

            mounted = false;
            window.removeEventListener("resize", handleResize);

        } );

    }, []);

    useEffect(() => {

        if (api) {

            api.refresh();

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps

    }, [onSelectMst.shipmentId]);

    const onApiInitialized = (api) => {

        setApi(api);

    };

    const notifySuccess = (msg) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });

    };

    const onNotifySuccess = ( msg ) => {

        notifySuccess ( msg );
        
        setApi ( ( api ) => {

            if ( api ) {

                api.refresh ();

            }

            return api;

        } );

    };

    const notifyFailure = (msg) => {
    
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
        
    };

    const onFailure = ( reason ) => {
    
        notifyFailure ( reason.response ? reason.response.data : reason );
    
    };

    const onInitialized = (grid) => {

        grid.selectionMode = "Row"
        setGrid(grid);

    };

    const onLoadData = (data) => {

        let isEmpty = data.length < 1 ? true : false;

        setIsEmpty(isEmpty);

        onDetailEmpty(isEmpty);

    };

    const onAppendButtonInFrontOfSearch = () => {

        return (
            <>
                <BasicCrudScreenActionItemLayout>
                        <TkDeliveryDetailButton
                            id={id}
                            schema={schema}
                            grid={grid}
                            onSelectMst = {onSelectMst}
                            refresh={api}
                            disabled={onSelectMst?.approvalState ? true : false || onSelectMst.length === 0 }
                            onSuccess={onNotifySuccess}
                        />

                        <DeleteRecordButton
                            id={id}
                            schema={schema}
                            grid={grid}
                            refresh={api}
                            color="secondary"
                            disabled={onSelectMst?.approvalState ? true : false || isEmpty }
                            onSuccess={onNotifySuccess}
                            onFailure={onFailure}
                        />
                </BasicCrudScreenActionItemLayout>
            </>
        );
    };

    return (
        <BasicCrudScreenType
            id= {id}
            table= {id}
            view = "TkVwDeliveryDetail"
            headerTitle={t("term.MomSysDeliveryDetail")}
            onModifyViewUrl={(url) => url + "/" + onSelectMst?.shipmentId}
            onApiInitialized={onApiInitialized}
            onInitialized={onInitialized}
            onAppendButtonInFrontOfSearch={onAppendButtonInFrontOfSearch}
            noCreate
            noEdit
            noDelete
            noExcel
            onLoadData={onLoadData}
        />
    );
}

export default MomSysDeliveryDetail;
